var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    className: "w-5 h-5 mr-3",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1,60h58c0.00781,0.00098,0.01465,0.00049,0.01953,0c0.55273,0,1-0.44775,1-1 c0-0.06982-0.00684-0.13818-0.02051-0.2041c-0.08496-10.33496-6.62695-19.6582-16.33203-23.24365 c-0.32031-0.11914-0.68164-0.06348-0.9541,0.14355C39.03027,38.51172,34.63477,40,30,40s-9.03027-1.48828-12.71289-4.3042 c-0.27148-0.20703-0.62988-0.2627-0.95313-0.14355c-3.34277,1.23291-6.45801,3.22803-9.01172,5.77148 C2.60059,46.05664,0,52.33398,0,59C0,59.55225,0.44727,60,1,60z M8.73633,42.73828c2.21973-2.21143,4.90332-3.97314,7.78711-5.11719 C20.46289,40.48779,25.11035,42,30,42s9.53711-1.51221,13.47656-4.37891C51.87598,40.95166,57.58301,48.99756,57.97852,58H2.02148 C2.2666,52.2417,4.62988,46.854,8.73633,42.73828z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30,0C19.52344,0,11,8.52344,11,19s8.52344,19,19,19s19-8.52344,19-19S40.47656,0,30,0z M30,36 c-9.37402,0-17-7.62598-17-17S20.62598,2,30,2s17,7.62598,17,17S39.37402,36,30,36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.91f511e78c6e891e1e053ef455298e7c.svg";
export { ForwardRef as ReactComponent };